document.addEventListener('DOMContentLoaded', () => {
    console.log("added");
  const mainBtn = document.querySelector('.cs-add-to-cart');
  const stickyWrapper = document.getElementById('stickyAddToCart');
  const stickyBtns = stickyWrapper ? stickyWrapper.querySelectorAll('.cs-add-to-sticky-btn') : [];

  if (!mainBtn || !stickyWrapper || stickyBtns.length === 0) return;

  function debounce(fn, wait = 80) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  function syncStickyState() {
    stickyBtns.forEach(stickyBtn => {
      if (mainBtn.classList.contains('disabled') || mainBtn.disabled) {
        stickyBtn.classList.add('disabled');
        stickyBtn.setAttribute('aria-disabled', 'true');
      } else {
        stickyBtn.classList.remove('disabled');
        stickyBtn.removeAttribute('aria-disabled');
      }
    });
  }

  function showSticky(shouldShow) {
    if (shouldShow) {
      if (!stickyWrapper.classList.contains('active')) {
        syncStickyState();
        stickyWrapper.classList.add('active');
        stickyWrapper.setAttribute('aria-hidden', 'false');
      }
    } else {
      if (stickyWrapper.classList.contains('active')) {
        stickyWrapper.classList.remove('active');
        stickyWrapper.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function computeMainBtnState({ headerHeight = 80, paddingBottom = 80 } = {}) {
    const r = mainBtn.getBoundingClientRect();
    const viewportBottom = window.innerHeight;
    const passedUp = r.bottom <= headerHeight;
    const belowViewport = r.top >= (viewportBottom - paddingBottom);
    const visible = (r.bottom > headerHeight) && (r.top < (viewportBottom - paddingBottom));
    return { passedUp, belowViewport, visible };
  }

  const handleVisibilityChange = debounce(() => {
    const { passedUp } = computeMainBtnState({ headerHeight: 80, paddingBottom: 80 });
    showSticky(passedUp);
  }, 100);

  stickyBtns.forEach(stickyBtn => {
    stickyBtn.addEventListener('click', (e) => {
      if (stickyBtn.classList.contains('disabled') || stickyBtn.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      const ev = new MouseEvent('click', { bubbles: true, cancelable: true, composed: true });
      mainBtn.dispatchEvent(ev);
      stickyBtn.classList.add('clicked');
      setTimeout(() => stickyBtn.classList.remove('clicked'), 200);
    });
  });

  const io = new IntersectionObserver(() => {
    handleVisibilityChange();
  }, { root: null, threshold: [0, 0.05, 0.5, 1] });

  io.observe(mainBtn);

  window.addEventListener('resize', handleVisibilityChange);
  window.addEventListener('orientationchange', handleVisibilityChange);
  window.addEventListener('scroll', debounce(handleVisibilityChange, 40));

  const mo = new MutationObserver(debounce(() => {
    syncStickyState();
    handleVisibilityChange();
  }, 60));

  mo.observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });

  syncStickyState();
  handleVisibilityChange();

  // Variant image switching
  const varBtn = document.querySelectorAll('.vart-btn');
  const prImg = document.querySelector('.product-img');

  varBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      prImg.src = btn.dataset.img;
    });
  });

  // Selected value sync
  const selecValue = document.querySelector('#selectedvalue');

  function changeSelecValue() {
    const selcValuetext = document.querySelector('.selectedbtn');
    if (selcValuetext && selecValue) {
      if (selecValue.innerHTML !== selcValuetext.innerHTML) {
        selecValue.innerHTML = selcValuetext.innerHTML;
      }
    }
  }

  changeSelecValue();

  const targetNode = document.querySelector('#stickyAddToCart');
  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          changeSelecValue();
        }
      }
    });

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
});
